import { useCallback } from 'react';
import { useScheduleRules } from '../../../../../../../../../components/ScheduleEmail/hooks/useScheduleRules';

export const useFormData = (sendTo: any[], contractId: string) => {
  const { getScheduleRules } = useScheduleRules();

  const getFormData = useCallback(
    (data: any, scheduleValues?: any) => {
      const request: any = {
        contractId,
        receivers: [],
      };

      for (const [key, value] of Object.entries(data)) {
        if (value === undefined || value === null) {
          continue;
        }

        if (key === 'sendTo') {
          data.sendTo.forEach((item: StringConstructor) => {
            const val = sendTo.find((data: any) => data.i.toString() === item);

            if (val) {
              const receiver: any = { email: val.email };

              if (val.id) {
                receiver.receiverId = val.id;
              }

              request.receivers.push(receiver);
            }
          });

          continue;
        }

        if (key === 'attachments') {
          const fileItemIds: string[] = [];

          data.attachments.forEach((item: any) =>
            fileItemIds.push(item.response),
          );

          request.fileItemIds = fileItemIds;

          continue;
        }

        request[key] = data[key];
      }

      const scheduleRules = getScheduleRules(scheduleValues);

      return { ...request, scheduleRules };
    },
    [contractId, sendTo, getScheduleRules],
  );

  return { getFormData };
};
